import React from 'react';
import { connect } from 'react-redux';
import { Translation } from 'react-i18next';
import { cloneDeep } from 'lodash';
import { getSkillsState } from '../../../../store/selectors';
import Chevron from '../../../user-dashboard/utility/Chevron';

export class SkillCourseTile extends React.Component {
  _isMounted = false;

  constructor(props) {
    super(props);
    this.state = {};
  }

  secondaryFill = {
    backgroundColor: `${this.props.tenant.secondary}`,
  };

  primaryFill = {
    backgroundColor: `${this.props.tenant.primary}`,
  };

  get secondaryBorderBottom() {
    return {
      borderBottom: `5px solid ${this.props.tenant.secondary}`,
      minWidth: this.props.tileWidth,
      marginRight: this.props.tileMargin,
    };
  }

  primaryColor = {
    color: `${this.props.tenant.primary}`,
  };

  handleClick = () => {
    this.setState((state, props) => {
      const { upskillOffering } = props;
      const displayOptions = cloneDeep(state[`display${upskillOffering}`]);

      return {
        [`display${upskillOffering}`]: !displayOptions,
      };
    });
  };

  render() {
    const { upskillOffering } = this.props;
    const caretTransform = this.state[`display${upskillOffering}`] ? 270 : 90;
    return (
      <Translation>
        {(t) => (
          <div className="skill-course-tile" style={this.secondaryBorderBottom}>
            <div className="skill-course-tile__image-box">
              <img
                className="skill-course-tile__image"
                src={this.props.photoUrl}
                alt={this.props.upskillOffering}
              />
              <div className="skill-course-tile__black-box">
                {this.props.type}
              </div>
            </div>
            <div className="skill-course-tile__content">
              <div className="skill-course-tile__course-title">
                {this.props.upskillOffering}
              </div>
              <button
                className="skill-course-tile__skills-dropdown-and-link"
                style={this.primaryColor}
                tabIndex={0}
                type="button"
                onClick={() => {
                  this.handleClick();
                }}
              >
                {t(`{{item}} Description`, { item: this.props.type })}
                <Chevron
                  color={this.props.tenant.primary}
                  transform={`rotate(${caretTransform}deg)`}
                  idName={this.props.upskillOffering}
                  height="10px"
                  marginLeft="2px"
                  ariaLabel={`${
                    this.state[`display${upskillOffering}`]
                      ? t(
                          'Click to close additional information about this offering'
                        )
                      : t(
                          'Click to open additional information about this offering'
                        )
                  }`}
                />
              </button>
              {this.state[`display${upskillOffering}`] ? (
                <>
                  <div
                    className="skill-course-tile__secondary-underline"
                    style={this.secondaryFill}
                  />
                  <div className="skill-course-tile__offering-description">
                    {this.props.description}
                  </div>
                </>
              ) : null}
              <div
                className="skill-course-tile__secondary-underline"
                style={this.secondaryFill}
              />
              <div className="skill-course-tile__link-container">
                <a
                  href={this.props.offeringUrl}
                  rel="noreferrer noopener"
                  target="_blank"
                  className="skill-course-tile__skills-dropdown-and-link"
                  style={this.primaryColor}
                  tabIndex={0}
                >
                  {t('Learn more')}
                </a>
              </div>
            </div>
          </div>
        )}
      </Translation>
    );
  }
}

const mapStateToProps = (state) => {
  const tenant = state.tenant;
  const skills = getSkillsState(state);
  return { tenant, skills };
};

export default connect(mapStateToProps)(SkillCourseTile);
